import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=6c93e4d0&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=6c93e4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c93e4d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c93e4d0')) {
      api.createRecord('6c93e4d0', component.options)
    } else {
      api.reload('6c93e4d0', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=6c93e4d0&scoped=true&", function () {
      api.rerender('6c93e4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/modal/DeleteModal.vue"
export default component.exports